module.exports = __webpack_public_path__ + "img/modal-document-clone.68bc8ca1.svg";